module.exports = __webpack_public_path__ + "static/media/nothing.014fe379.png";